<template>
  <div class="page-content">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <h4 class="h4-white">Demonstrativo Repasse</h4>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-between justify-content-md-end"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemonstrativoRepasseActions", 
    data() {
      return {
        tokens: {},
        linkWebKit: ""
      };
    }, 
    created: function() {
      this.init();
    },
    methods: {    
      init: function() {
        this.getTokens();
      },
      getTokens: function() {
        this.tokens = this.$cooperadowebapi.tokens.get("usuario");
      },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseActions.vue